/**
 * HOC component for formatting numbers. Currently used for formatting currency values.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_LOCALE } from '../../config/config';
import { ApplicationState } from '../../store';
import { getLocale } from '../../store/common/sagas';
import { AppCommonState } from '../../store/common/types';

export const withNumberFormatHandler = (WrappedComponent: any) => {
    const NumberFormatHandler: React.FC<any> = (props: any) => {
        const locale = useSelector(getLocale) || DEFAULT_LOCALE;
        const appState: AppCommonState = useSelector(
            (state: ApplicationState) => state.app
        );
        const formatCurrency = (amount: number = 0) => {
            return Intl.NumberFormat(locale, {
                style: 'currency',
                currency: appState.currencyCode,
            }).format(amount);
        };

        const formatToParts = (amount: number) => {
            return Intl.NumberFormat(locale, {
                style: 'currency',
                currency: appState.currencyCode,
            }).formatToParts(amount);
        };

        const formatNumber = (value: number, decimalScale: number = 0) => {
            return Intl.NumberFormat(locale, {
                minimumFractionDigits: decimalScale,
            }).format(value);
        };

        return (
            <WrappedComponent
                {...props}
                formatCurrency={formatCurrency}
                formatNumber={formatNumber}
                formatToParts={formatToParts}
            />
        );
    };

    return NumberFormatHandler;
};
